import { FC } from 'react';
import './styles.css';
import { Logo } from 'src/config/components/Logo';

export const VideoPreloader: FC = () => (
  <div className="h-screen flex flex-col justify-center items-center">
    <Logo className="max-w-[400px] w-[90%]" />
    <div className="loader" />
  </div>
);
